import { futureValueLumpsum } from "../../engine/calculations";

const lumpsumFutureValueConfig = {
  key: "lumpsum-future-value",
  title: "Lumpsum Future Value",
  category: "Growth",
  description: "See what a one-time investment grows into over time.",
  fields: [
    { key: "amount", label: "Investment amount", type: "currency", default: 5_00_000, min: 1000, max: 10_00_00_000, help: "The one-time amount you invest today.", profileKey: "netWorth" },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn", help: "Long-term expected return, e.g. 12% for equity mutual funds." },
    { key: "years", label: "Investment period (years)", type: "number", default: 10, min: 1, max: 40 },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "invested", label: "Invested", colorVar: "--muted" },
      { key: "value", label: "Value", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const amount = Number(values.amount) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const futureValue = futureValueLumpsum(amount, annualRate, years);
    const gains = futureValue - amount;

    const series = [];
    for (let y = 1; y <= years; y++) {
      series.push({ year: y, invested: amount, value: futureValueLumpsum(amount, annualRate, y) });
    }

    return {
      headline: { label: "Future Value", value: futureValue },
      breakdown: [
        { label: "Principal", value: amount },
        { label: "Estimated Gains", value: gains },
      ],
      series,
    };
  },
};

export default lumpsumFutureValueConfig;
